import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import PhoneOutlinedIcon from '@material-ui/icons/PhoneOutlined';
import { Box, Container, Link, Typography } from '@mui/material';
import logo from '../assets/img/logol.png';
const Footer = () => {
    return (
        <Box
            component="footer"
            id="footer"
            sx={{
                bgcolor: 'background.paper',
                borderTop: '1px solid',
                borderColor: 'divider',
                py: 6,
            }}
        >
            <Container maxWidth="lg">
                <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' },
                    gap: 4,
                    mb: 4
                }}>
                    {/* Brand */}
                    <Box>
                        <Box sx={{ mb: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: 40,
                                        height: 40,
                                        borderRadius: 2,
                                        background: "linear-gradient(173deg, #6f41e37d 0%, #e7616930 100%)",     // 'linear-gradient(135deg, #7C3AED 0%, #10B981 100%)',
                                        overflow: 'hidden'
                                    }}
                                >
                                    {/* <SchoolOutlinedIcon htmlColor='#fff' sx={{ fontSize: 24 }} /> */}
                                    <img
                                        src={logo}
                                        alt="brand logo"
                                        style={{
                                            width: "70%",
                                            height: "70%",
                                            objectFit: "contain",
                                        }}
                                    />
                                </Box>
                                <Typography variant="h6" fontWeight={700} sx={{ textTransform: 'none' }}>
                                    <Box component="span" sx={{ color: '#3c83f6' }}>learning</Box>
                                    <Box component="span" sx={{ color: '#f59f0a' }}>Fitbit</Box>
                                </Typography>
                            </Box>
                            <Typography variant="body2" color="text.secondary">
                                Empowering education with innovative hybrid learning solutions for students and educators.
                            </Typography>
                        </Box>
                    </Box>

                    {/* Quick Links */}
                    <Box>
                        <Typography variant="h6" fontWeight={600} gutterBottom>
                            Quick Links
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Link
                                href={'/terms'}
                                target="_blank" color="text.secondary" underline="hover">
                                Terms and conditions
                            </Link>
                            <Link
                                href={'/disclaimer'}
                                target="_blank" color="text.secondary" underline="hover">
                                Disclaimer
                            </Link>
                            <Link
                                href={'/privacy'}
                                target="_blank" color="text.secondary" underline="hover">
                                Privacy Policy
                            </Link>
                            <Link
                                href={'/refund'}
                                target="_blank" color="text.secondary" underline="hover">
                                Refund Policy
                            </Link>
                            <Link
                                href={'/deliverypolicy'}
                                target="_blank" color="text.secondary" underline="hover">
                                Delivery Policy
                            </Link>
                            {/* <Link href="#about" color="text.secondary" underline="hover">About</Link>
                            <Link href="#services" color="text.secondary" underline="hover">Services</Link> */}
                        </Box>
                    </Box>

                    {/* Services */}
                    <Box>
                        <Typography variant="h6" fontWeight={600} gutterBottom>
                            Services
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Typography variant="body2" color="text.secondary">Test Series</Typography>
                            <Typography variant="body2" color="text.secondary">Question Banks</Typography>
                            <Typography variant="body2" color="text.secondary">Analytics & Insights</Typography>
                            <Typography variant="body2" color="text.secondary">White Labelling</Typography>
                            <Typography variant="body2" color="text.secondary">Hybrid Learning</Typography>
                        </Box>
                    </Box>

                    {/* Contact */}
                    <Box>
                        <Typography variant="h6" fontWeight={600} gutterBottom>
                            Contact Us
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
                                <EmailOutlinedIcon sx={{ color: 'primary.main', fontSize: 18, mt: 0.5 }} />
                                <Typography variant="body2" color="text.secondary">
                                    support@splayndid.com
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
                                <PhoneOutlinedIcon sx={{ color: 'primary.main', fontSize: 18, mt: 0.5 }} />
                                <Typography variant="body2" color="text.secondary">
                                    +91 78219 21518
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
                                <LocationOnOutlinedIcon sx={{ color: 'primary.main', fontSize: 18, mt: 0.5 }} />
                                <Typography variant="body2" color="text.secondary">
                                    India
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box>

                {/* Bottom Bar */}
                <Box sx={{ pt: 4, borderTop: '1px solid', borderColor: 'divider', textAlign: 'center' }}>
                    <Typography variant="body2" color="text.secondary">
                        © {new Date().getFullYear()} learningFitbit. All rights reserved.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;
